import { useUser } from '@ad-lucy/gateway-provider';
import type { PermissionRequirement } from '@ad-lucy/permissions';
import NotFoundView from '@modules/components/NotFoundView';
import type { PropsWithChildren, ReactNode } from 'react';

type ACLProps = PropsWithChildren<{
  require: PermissionRequirement;
  fallback?: ReactNode;
}>;

export function Acl({
  require,
  children,
  fallback = <NotFoundView />,
}: ACLProps) {
  const user = useUser();
  return <>{user.require(require) ? children : fallback}</>;
}
